import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue, { WatchOptions } from 'vue';
import { SelectOptionDTO } from '@/models/SelectOptionDTO';

@Component
export default class InputSelect extends Vue {
  @Prop({ required: true }) public name?: string;
  @Prop() public label?: string;
  @Prop({ default: false }) public required?: boolean;
  @Prop({ default: false }) public disabled?: boolean;
  @Prop({ default: false }) public readonly?: boolean;
  @Prop() public value?: string;
  @Prop({ required: true }) public options?: SelectOptionDTO[];
  protected randomId: string = Math.floor(Math.random() * Math.floor(100000000)).toString();
  private selected?: string = '';
  private text: string = '';

  protected mounted() {
    // this.inputType = 'select';
    if (this.value !== undefined) {
      this.selected = this.value;
      this.setText();
    }
  }

  protected setText() {
    const selectedOption = (this.options as SelectOptionDTO[]).find((x: SelectOptionDTO) => x.value === this.selected);
    if (selectedOption) {
      this.text = selectedOption.text;
    } else {
      this.text = '';
    }
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: string, oldValue: string) {
    if (oldValue !== value && value !== undefined) {
      this.selected = this.value;
      this.setText();
    }
  }
}

